import React, { useMemo } from "react";
import { Tooltip } from "antd";
import dayjs from "dayjs";
import "../styles/eventFormStyles.css";
import ChantSelect from "../../../../../../CommonComponents/ChantSelect/ChantSelect";
import useContentFormParams from "../hooks/useContentFormParams";

export const MatchSelector = ({
  value,
  onChange,
  matchList,
  clubId,
  matchDate,
  awayTeam,
  matchName,
  isPastEvent = false,
}) => {
  const { formMode } = useContentFormParams();
  const fixTimestamp = (date) => {
    return String(date).length === 10 ? dayjs.unix(date) : dayjs(date);
  };

  const getTimeFromMatchName = (name) => {
    // Try new format first: (14th Jan, 2026)
    let match = name?.match(/\((\d{1,2}[a-z]{2} [A-Za-z]+, \d{4})\)/);
    // Fallback to old format for backward compatibility: (14th-Jan-26)
    if (!match) {
      match = name?.match(/\((\d{1,2}[a-z]{2}-[A-Za-z]+-\d{2})\)/);
    }
    return match ? match[1] : null;
  };

  const getOpponentTeamName = (clubId, homeTeam, awayTeam) => {
    if (String(clubId) === String(awayTeam?.team_id)) {
      return homeTeam?.team_name;
    }
    return awayTeam?.team_name;
  };

  const options = useMemo(() => {
    // For view mode or edit mode with past events, show only the current match
    if (
      (formMode === "view" || (formMode === "edit" && isPastEvent)) &&
      value
    ) {
      const matchLabel = matchDate
        ? `${awayTeam?.team_name} ( ${dayjs(fixTimestamp(matchDate)).format(
            "Do MMM, YYYY"
          )} )`
        : `${awayTeam?.team_name} (${getTimeFromMatchName(matchName)})`;

      return [
        {
          value: Number(value),
          label: matchLabel,
        },
      ];
    }

    // For create, copy, and edit modes (current events), use matchList to show available matches
    return matchList
      .filter((match) => dayjs(match.event_date).valueOf() > Date.now())
      .map((match) => ({
        value: match.fixture_id,
        label: `${getOpponentTeamName(
          clubId,
          match.homeTeam,
          match.awayTeam
        )} (${dayjs(match.event_date).format("Do MMM, YYYY")})`,
      }));
  }, [
    formMode,
    value,
    matchList,
    clubId,
    matchDate,
    awayTeam,
    matchName,
    isPastEvent,
  ]);

  const handleChange = (selectedValue) => {
    const syntheticEvent = {
      target: {
        value: selectedValue || "",
      },
    };
    onChange(syntheticEvent);
  };

  const placeholder = "--Select Match--";

  return (
    <ChantSelect
      label={
        <>
          Match
          <Tooltip
            placement="topLeft"
            title="If selected, event will appear in Match Day immediately upon submission and not expire. Opponent logo will appear on content card."
          >
            <span style={{ marginLeft: "4px" }}>
              <i className="fa fa-question-circle-o" />
            </span>
          </Tooltip>
        </>
      }
      options={options}
      value={Number(value) || undefined}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={formMode === "view" || (formMode === "edit" && isPastEvent)}
      allowClear={true}
    />
  );
};
